import { Injectable } from '@angular/core';
import * as SendBird from "sendbird";
import { environment } from 'src/environments/environment';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SendbirdService {

  sb: any;
  channelHandler = new Subject<any>();
  userId:any;

  constructor() { }

  init() {
    if (!this.sb) {
      this.sb = new SendBird({ appId: environment.sendBird.application_Id });

      var channelHandler = new this.sb.ChannelHandler();

      channelHandler.onMessageReceived = (channel, message) => {
        this.channelHandler.next({ channel: channel, message: message });
      };

      this.sb.addChannelHandler('UNIQUE_HANDLER_ID', channelHandler);
      var connectionHandler = new this.sb.ConnectionHandler();

      connectionHandler.onReconnectStarted = function () {
        console.log('reconnect started');
      };
      connectionHandler.onReconnectSucceeded = function () {
        console.log('reconnect succeded');
      };
      connectionHandler.onReconnectFailed = () => {
        console.log('reconnect failedd');
        this.connect(this.userId, '', () => {

        });
      };
      this.sb.addConnectionHandler("UNIQUE_CONNECTION_HANDLER_ID", connectionHandler);
    }
  }


  subScribeChannelHandler(): Observable<any> {
    return this.channelHandler.asObservable();
  }

  connect(id, token, callback) {
    if (!this.sb.currentUser || this.sb.currentUser.userId != id) {
      this.sb.connect(id, environment.sendBird.SECONDARY_API_TOKENS, (user, error) => {
        if (error) {
          console.log("Error while connecting chat user", error);
          callback(error);
        } else {
          this.userId = id;
          callback(error);
        }
      });
    } else {
      callback(false);
    }
  }

  getOpenChannel(url, trial, callback) {
    trial = trial || 1;
    this.sb.OpenChannel.getChannel(url, (channel, error) => {
      console.log("TRIAL:", trial, url)
      if (error && error.code != 400201 && trial <= 2) {
        trial++;
        this.getOpenChannel(url, trial, callback);
      } else {
        callback(channel, error);
      }
    })
  }

  enterChannel(channel, trial, callback) {
    channel.enter((response, error) => {
      console.log("ENTER TRIAL:", trial, channel.name);      
      if (error && error.code == 800180 && trial<= 2) {
        console.log("CHANNEL ERROR:", error.message, error.code);        
        trial++;
        this.enterChannel(channel, trial, callback);
      } else {
        callback(response, error);
      }
    });
  }

  disconnect() {
    this.sb.disconnect(function () {
      // A current user is discconected from Sendbird server.
    });
  }

}
